function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import App from 'modules/App';
import Account from 'modules/Account';
import * as constants from '../../../constants';
import messages from '../../../messages';
const ImportPatientDatabase = ()=>{
    const activeClinicMembership = useSelector(Account.selectors.activeClinicMembership);
    const isAdmin = get(activeClinicMembership, 'isAdmin', false);
    const onOpenModal = useAction(App.actions.openModal, constants.IMPORT_PATIENT_DATABASE_MODAL);
    if (!isAdmin) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("section", {
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "section__header",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.importPatientDatabase))
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "section__intro",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.intros.importPatientDatabase))
            }),
            /*#__PURE__*/ _jsx(Button, {
                styleModifier: "primary",
                labelMessage: messages.buttons.import,
                className: "btn--filled",
                onClick: onOpenModal
            })
        ]
    });
};
export default ImportPatientDatabase;
